/*
 * nutrition-drawer.js — opens the Nutritional Facts drawer from its accordion row, switches
 * flavours, and closes on overlay, X, Dismiss or Escape. One drawer per product block.
 *
 * On open it pre-selects the flavour the shopper has picked in the Skio bundle picker (first
 * selected chip), so the panel she lands on is the one she is about to buy.
 */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function Drawer(el) {
    this.el = el;
    this.panel = qs(el, '.nutrition-drawer__panel');
    this.select = qs(el, '[data-nutrition-select]');
    this.selectButton = qs(el, '[data-nutrition-select-button]');
    this.selectList = qs(el, '[data-nutrition-select-list]');
    this.options = qsa(el, '[data-nutrition-option]');
    this.panels = qsa(el, '[data-nutrition-panel]');
    this.lastFocus = null;
    this.bind();
  }

  Drawer.prototype.bind = function () {
    var self = this;
    qsa(this.el, '[data-nutrition-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    this.selectButton.addEventListener('click', function () { self.toggleList(); });
    this.options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        self.show(parseInt(opt.getAttribute('data-nutrition-option'), 10));
        self.toggleList(false);
        self.selectButton.focus();
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var i = self.options.indexOf(opt) + (e.key === 'ArrowDown' ? 1 : -1);
          var next = self.options[(i + self.options.length) % self.options.length];
          next.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!self.select.contains(e.target)) self.toggleList(false);
    });
    this.el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!self.selectList.hidden) { self.toggleList(false); self.selectButton.focus(); }
        else self.close();
      }
    });
  };

  Drawer.prototype.toggleList = function (force) {
    var open = typeof force === 'boolean' ? force : this.selectList.hidden;
    this.selectList.hidden = !open;
    this.select.classList.toggle('is-open', open);
    this.selectButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var current = this.options.filter(function (o) { return o.classList.contains('is-selected'); })[0] || this.options[0];
      if (current) current.focus();
    }
  };

  Drawer.prototype.show = function (index) {
    var opt = this.options[index];
    if (!opt) return;
    this.options.forEach(function (o, i) {
      var on = i === index;
      o.classList.toggle('is-selected', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panels.forEach(function (p, i) {
      var on = i === index;
      p.hidden = !on;
      p.classList.toggle('is-active', on);
    });
    var name = opt.getAttribute('data-name');
    var color = opt.getAttribute('data-color');
    qs(this.el, '[data-nutrition-select-label]').textContent = name;
    qs(this.el, '[data-nutrition-select-dot]').style.background = color;
    qs(this.el, '[data-nutrition-chip-name]').textContent = name;
    qs(this.el, '[data-nutrition-chip-dot]').style.background = color;
    this.panel.scrollTop = 0;
  };

  /* Match the picker's first selected flavour chip to a drawer option, if both exist. */
  Drawer.prototype.syncWithPicker = function () {
    var chip = document.querySelector('.skio-bundle__chip.is-selected .skio-bundle__chip-name');
    if (!chip) return;
    var picked = chip.textContent.trim().toLowerCase();
    var idx = -1;
    this.options.forEach(function (o, i) {
      var n = o.getAttribute('data-name').toLowerCase();
      if (idx === -1 && (picked.indexOf(n) === 0 || n.indexOf(picked) === 0)) idx = i;
    });
    if (idx > -1) this.show(idx);
  };

  Drawer.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.syncWithPicker();
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nutrition-drawer-open');
    var self = this;
    setTimeout(function () { self.panel.focus(); }, 50);
  };

  Drawer.prototype.close = function () {
    this.toggleList(false);
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nutrition-drawer-open');
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
  };

  var drawers = {};

  function init() {
    qsa(document, '.nutrition-drawer').forEach(function (el) {
      if (drawers[el.id]) return;
      /*
       * Moved to the end of <body>: the cookie bar and other apps sit at the maximum z-index,
       * and at equal z-index the later element paints on top. It also keeps the fixed panel
       * clear of any transformed ancestor in the product template.
       */
      if (el.parentElement !== document.body) document.body.appendChild(el);
      drawers[el.id] = new Drawer(el);
    });
    qsa(document, '[data-nutrition-open]').forEach(function (btn) {
      if (btn.dataset.nutritionReady) return;
      btn.dataset.nutritionReady = '1';
      btn.addEventListener('click', function () {
        var d = drawers[btn.getAttribute('data-nutrition-open')];
        if (d) d.open();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
